import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DgActionService {
  constructor(private http: HttpClient) {}
  sendCaseToAnyone(postData): Observable<any> {
    return this.http.post('/workflow/workflow-operation', postData);
  }
  caseReopen(postData: { caseID: number }): Observable<any> {
    return this.http.put('/case-mgmnt/reopen-case', postData);
  }
  getRefDocs(postData) {
    return this.http.post('/case-mgmnt/ref-docs-in-case', postData);
    //  .subscribe((res) => {
    //    console.log(res);
    //  });
  }
  getNotings(postData) {
    // this.http.get('case-mgmnt/notings', postData).subscribe((res) => {
    //   console.log(res);Number(488534)
    // });

    let params = new HttpParams()
      .set('recId', postData.fileId) //2470 for attachment check
      /*  .set("recId",'2470') */ .set('appTypId', '1')

      .set('isPaginReq', 'true')
      .set('noteTypeArr', '193')
      .set('tabOpenFlag', '1')
      .set('mvmntPk', postData.mvmntPk);
    // params = params.append('recId', '487943');
    // params = params.append('appTypId', '1');
    // params = params.append('isPaginReq', 'true');
    // params = params.append('noteTypeArr', '193');
    // params = params.append('tabOpenFlag', '1');
    params = params.append('startIndex', '1');
    params = params.append('rowsPerPage', '5');
    // params = params.append('openFrom', '4');
    return this.http.get('/case-mgmnt/notings', { params: params });
    //  .subscribe((res) => {
    //     console.log(res);
    //   });
  }
  getCaseDetails(postData) {
    //   fileId: this.data.selectedData[0].docId,
    //   dbSchema: -1,
    //   mvmntPk: null,
    //   applicationTypeId: 1,
    //   openFrom: 1,
    let params = new HttpParams()
      .set('fileId', postData)
      .set('dbSchema', '-1')
      .set('mvntPk', ' null')
      .set('applicationTypeId', '1')
      .set('openFrom', '1');
    return this.http.get('/case-mgmnt/case-details', { params: params });
    // .subscribe((res) => {
    //   console.log(res);
    //   // this.subjectDescription = res.data.subjectName;data.fileNo
    // });
  }
  create(postData) {
    return this.http.post('/case-mgmnt/create-part-file', postData);
  }
}
